import { MappedProfileType } from '../../../components/socialProfiles/SocialProfileListItem/SocialProfileListItem.view';
import { PostFeedType } from '../../../models/graphql';

export const canAddComment = (selectedProfiles: MappedProfileType[], feedType: PostFeedType) =>
  selectedProfiles.reduce((previous, current) => {
    if (previous) return true;
    switch (current.__typename) {
      case 'LinkedInSocialProfile':
        return true;
      case 'FacebookSocialProfile':
        return current.type === 'page';
      case 'InstagramSocialProfile':
        return current.directPublishEnabled && feedType !== PostFeedType.STORY;
      default:
        return false;
    }
  }, false);
